"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../index");

var _index2 = require("../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _addablefields_styles = _interopRequireDefault(require("./addablefields_styles"));

var _addablefields_definition = _interopRequireDefault(require("./addablefields_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : ADDABLE FIELDS ~~~~~~~~~~ ========== */


var AddableFields = (0, _reactJss.default)(_addablefields_styles.default)(function (props) {
  var addNewField = function addNewField() {
    return props.newField();
  };

  var removeExistingField = function removeExistingField(idx) {
    return props.removeField(idx);
  };

  var fieldTemplate = function fieldTemplate() {
    var fieldValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var idx = arguments.length > 1 ? arguments[1] : undefined;
    return _react.default.createElement("div", {
      key: idx * 6,
      className: "addablefield"
    }, _react.default.createElement(_index.TextField, {
      name: props.name,
      type: 'text',
      label: null,
      placeholder: props.placeholder,
      value: fieldValue,
      handleChange: function handleChange(e) {
        return props.handleChange(e.target.value, idx);
      }
    }), _react.default.createElement(_index.Link, {
      name: 'removefield',
      type: 'action',
      variant: 'primary',
      text: '',
      icon: 'minus-circle',
      operation: 'link',
      behavior: 'none',
      handleClick: function handleClick() {
        return removeExistingField(idx);
      },
      iconRight: false,
      color: 'error'
    }));
  };

  var renderFields = function renderFields() {
    return props.fieldData.map(function (fieldVal, idx) {
      return fieldTemplate(fieldVal, idx);
    });
  };

  return _react.default.createElement("div", {
    className: "addablefields ".concat(props.classes.addablefields)
  }, _react.default.createElement("div", {
    className: 'fields'
  }, _react.default.createElement(_index.Label, null, props.label), renderFields()), _react.default.createElement(_index.Link, {
    name: 'addfield',
    type: 'action',
    variant: 'primary',
    text: props.ctaText,
    icon: 'plus-circle',
    operation: 'link',
    behavior: 'none',
    action: addNewField,
    iconRight: true,
    color: 'primary'
  }));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(AddableFields, _addablefields_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = AddableFields;
exports.default = _default;